export const ddDMSConfig = {
  organization_id: 'brfgrindstugan',
};
